import logo from './logo.svg';
import './App.css';
import CustomCart from './components/CustomCart';
import NewCart from './components/NewCart';
import {Routes, Route,Link} from "react-router-dom"
import Checkout from './components/Checkout';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import ZoomPhone from './components/ZoomPhone';
import LawPayCheckout from './components/LawPayCheckout'
import DepositByClient from './components/DepostByClient';
import Questionnaire from './components/Questionnaire';
import Notary from './components/Notary';
import QuestionnaireTwo from './components/Questionnaire2';
function App() {
  return (
    <div >

      <Routes>
        <Route path="/custom" element={<CustomCart />} />
        <Route path='/' element={<NewCart/>}></Route>
        <Route path='/checkout' element={<Checkout/>}></Route>
        <Route path='/lawpay' element={<LawPayCheckout/>}></Route>
        <Route path='/phonecall' element={<ZoomPhone/>}></Route>
        <Route path='/deposit' element={<DepositByClient/>}></Route>
        {/* <Route path='/questionnaire' element={<QuestionnaireTwo/>}></Route> */}
         <Route path='/notary' element={<Notary/>}></Route>
        <Route path='/questionnaire' element={<Questionnaire/>}></Route>
      </Routes>
    </div>
  );
}

export default App;
